import CardSimulaciones from "./components/CardSimulaciones";
import CardSalaSistema from "./components/CardSalaSistema";

const Galeria = () => {
    return (
        <>
            <CardSimulaciones />
            <CardSalaSistema /> 
        </>
    );
};

export default Galeria;
